import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-expiration',
  templateUrl: './payment-expiration.component.html',
  styleUrls: ['./payment-expiration.component.scss']
})
export class PaymentExpirationComponent implements OnInit {

  @Input() expiration: string;

  constructor() { }

  ngOnInit() {
  }

}
